import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { ProductReturn } from '../../shared/models/sale/product-return';
import { ProductReturnReasonOption } from '../../shared/models/sale/product-return-reason-option';
import { ProductReturnCreditNoteOperationType } from '../../shared/models/sale/product-return-credit-note-operation-type';

export const returnApi = createApi({
  reducerPath: 'returnApi',
  baseQuery,
  endpoints: (builder) => ({
    returnList: builder.query<IPagedResult<ProductReturn>, string>({
      query: (params) => ({
        url: `/api/productreturns?${params}`,
        method: 'GET',
      }),
    }),
    getReturnReasons: builder.query<ProductReturnReasonOption[], void>({
      query: () => ({
        url: `/api/productreturns/reasons`,
        method: 'GET',
      }),
    }),
    getCreditNoteOperationTypes: builder.query<ProductReturnCreditNoteOperationType[], void>({
      query: () => ({
        url: `/api/creditnotetypes`,
        method: 'GET',
      }),
    }),
    addReturn: builder.mutation<ProductReturn, ProductReturn>({
      query: (values) => ({
        url: `/api/productreturns`,
        method: 'POST',
        body: values,
      }),
    }),
  }),
});

export const {
  useLazyReturnListQuery,
  useAddReturnMutation,
  useGetReturnReasonsQuery,
  useGetCreditNoteOperationTypesQuery,
} = returnApi;
